import { Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'compare'})
export class ComparePipe implements PipeTransform {

	transform(list: any[], filterByField: string, operator: string, filterValue: any): any {
		if (!list || !filterByField || filterValue == undefined || filterValue == null) {
			return list;
		}

		return list.filter(item => {
			const field = item[filterByField];

			if (operator === '>') {
				return field > filterValue;

			} else if (operator === '>=') {
				return field >= filterValue;

			} else if (operator === '<') {
				return field < filterValue;

			} else if (operator === '<=') {
				return field <= filterValue;

			} else if (operator === '==') {
				return field == filterValue;

			} else if (operator === '!=') {
				return field != filterValue;

			} else {
				return true;
			}
			
		});
	}


}


// WEBPACK FOOTER //
// ./src/app/pipes/compare-pipe.ts